<div class="trophies-list-item" *ngIf="item && trophyData" [ngClass]="{'complete': isComplete}">
  <div class="trophies-list-item__icon">
    <brt-trophy-icon [trophy]="trophyData" [completed]="isComplete"></brt-trophy-icon>
  </div>

  <div class="trophies-list-item__content">
    <div class="trophies-list-item__name">{{itemTitle}}</div>
    <div class="trophies-list-item__description">{{itemDescription}}</div>

    <div class="trophies-list-item__progress">
      <div class="trophies-list-item__progress-fill" [ngStyle]="{width: item.percentValue + '%'}"></div>
      <div class="trophies-list-item__progress-label">
        <ng-container *ngIf="isComplete; else percentValue">
          <brt-icon [icon]="'check'"></brt-icon>
        </ng-container>
        <ng-template #percentValue>
          {{(item.percentValue).toFixed(0)}}%
        </ng-template>
        </div>
    </div>
  </div>
</div>
